function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { Fragment } from 'react';
import { attrToProp } from '../../utils';
export const PlaceholderFallbackHydrate = ({
  id,
  content
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    "data-lazy-begin": id
  }), content.map((el, i) => {
    const {
      tagName = '',
      childNodes = [],
      attributes = []
    } = el;
    const props = Array.from(attributes).reduce(attrToProp, {
      key: String(i)
    }); // text node

    if (!tagName) return React.createElement(Fragment, props, el.textContent); // childless tag

    if (!childNodes.length) return React.createElement(tagName.toLowerCase(), props); // tag with content

    return React.createElement(tagName.toLowerCase(), _extends(_extends({}, props), {}, {
      dangerouslySetInnerHTML: {
        __html: ''
      },
      suppressHydrationWarning: true
    }));
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    "data-lazy-end": id
  }));
};